import type { AccountRequestType } from '../Settings/SettingsApi';

export const defaultAccount: AccountRequestType = {
    name: '',
    email: '',
    expiration_date: '',
    is_expired: false,
};
